export default __webpack_public_path__ + "static/media/bigknife.efffb507.png";